module.exports = __webpack_public_path__ + "img/prakerja.0363cd99.webp";